import { twMerge } from "tailwind-merge";
import { ClassValue, clsx } from "clsx";

/**
 * Helper function to merge tailwind classes
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
